import { Controller } from '@hotwired/stimulus';
import { getRequest } from '../src/utils';

// Connects to data-controller="signup"
// Used in new student form
// Purpose: use student's year group and school input to fetch band space availability information (no. spaces available and first lesson date)
// To be improved: school dropdown is using select2 which does not have an event on school choice so school needs to be selected first and on year group selection the api is called
export default class extends Controller {
  static targets = [
    'info', // band space info target (one for date and one for space availability)
    // below are space and date target for each instrument
    'vocalsSpace',
    'drumsSpace',
    'guitarSpace',
    'keyboardSpace',
    'vocalsDate',
    'drumsDate',
    'guitarDate',
    'keyboardDate',
    'schoolInput', // school input target
    'yearGroupInput', // year group input target
  ];
  static values = [{ yearGroupInputValue: Number }];
  connect() {
    console.log('signup controller connected');
  }

  // display band space information by instrument on selection of year group
  async dog() {
    console.log(this.yearGroupInputTarget, this.yearGroupInputTargets);
    // get the checked year group and assign to year group input value
    let checked = this.yearGroupInputTargets.find((target) => target.checked);
    this.yearGroupInputValue = checked.value;

    // if school and year group have both been selected, fetch the available spaces informatino
    if (this.schoolInputTarget.value && this.yearGroupInputTarget.value) {
      try {
        let availableSpaces = await this.fetchSpacesAvailability();
        console.log('availableSpaces', availableSpaces);
        if (availableSpaces.new_school) {
          // for new schools, add 'sign up' as text information
          ['vocals', 'drums', 'guitar', 'keyboard'].forEach((instrument) => {
            this[`${instrument}SpaceTarget`].innerHTML = `<span>Sign up</span>`;
          });
        } else {
          // for active schools, display the band space information
          Object.keys(availableSpaces).forEach((space) => {
            let count = Number.parseInt(
              availableSpaces[space].available_spaces
            );
            let nextClass = availableSpaces[space].next_newcommer_class;
            this[`${space}SpaceTarget`].innerHTML =
              count == 0
                ? 'Join waiting list'
                : count == 1
                ? `<span class="text-red-500"> ${count} spot available</span>`
                : `<span> ${count} spots available</span>`;

            this[`${space}DateTarget`].innerHTML =
              count == 0 ? '' : `<span>Starting on: ${nextClass}</span>`;
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  async fetchSpacesAvailability() {
    // use school and year group inputs to fetch band space availability info
    try {
      let resp = await getRequest(
        `/admin/band_spaces/get_availability?school_id=${this.schoolInputTarget.value}&year_group=${this.yearGroupInputValue}`
      );
      let data = await resp.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  // we need to send {school: 1, yearGroup: 2}

  // then we need to caluclate each bands acceptanceRange (average year group as range ex. 1-2 for 1.35)

  // then we need to see how many total spots for each instrument in this acceptance range

  // include spots currently occupied with a "leaving" student

  // First you check empty spots, then if no empty, check leaving spots, then if still nothing, you say waitng list

  // just get all empty spots including spots with leaving, and then jsut display earliest start date

  // we want to fetch {vocals: {firstLessonDate: "", spots: ""}, ...}

  // if there are no spots, don't say 0 spots, just say "waiting list" & don't show date

  // on choice of instrument, we want to fetch {booking: {firstLessonDate: "", regularPayment: "", firstPaymentDate: "", firstPaymentAmount: "", firstPaymentCovers: ""}}
}

// How we calc the spaces available:
// 1. Each band has acceptane range, if student year group is within the range and the band has spots, show it

// Grab bands where the student is within the acceptance range
